export default "__VITE_PUBLIC_ASSET__f746990e__"